(function () {
    'use strict';

    angular.module("imApp").factory("productionRoutingWorkService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3653,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3654,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 3655,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
